var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),(this.toasts)?_c('toast'):_vm._e(),_c('main',{attrs:{"role":"main"}},[_c('router-view')],1),_c('common-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }